// extracted by mini-css-extract-plugin
export var listSummitAgenda = "text-summit-module--list-summit-agenda--e3bff";
export var tags = "text-summit-module--tags--6845a";